import React from 'react';
import { Hero } from './components/commercial/Hero';
import { TrustBar } from './components/commercial/TrustBar';
import { Services } from './components/commercial/Services';
import { Reviews } from './components/commercial/Reviews';
import { ProjectTypes } from './components/commercial/ProjectTypes';
import { Storefronts } from './components/commercial/Storefronts';
import { InteriorGlass } from './components/commercial/InteriorGlass';
import { ContractGlazing } from './components/commercial/ContractGlazing';
import { ProjectShowcase } from './components/commercial/ProjectShowcase';
import { Industries } from './components/commercial/Industries';
import { Process } from './components/commercial/Process';
import { WhyChoose } from './components/commercial/WhyChoose';
import { Locations } from './components/commercial/Locations';
import { FAQ } from './components/commercial/FAQ';
import { FinalCTA } from './components/commercial/FinalCTA';
import { MobileStickyCTA } from './components/commercial/MobileStickyCTA';
export function App() {
  return <main className="w-full min-h-screen bg-cream-100 pb-20 md:pb-0" data-id="element-0">
      <Hero data-id="element-1" />
      <TrustBar data-id="element-2" />
      <Services data-id="element-3" />
      <Reviews data-id="element-4" />
      <ProjectTypes data-id="element-5" />
      <Storefronts data-id="element-6" />
      <InteriorGlass data-id="element-7" />
      <ContractGlazing data-id="element-8" />
      <ProjectShowcase data-id="element-9" />
      <Industries data-id="element-10" />
      <Process data-id="element-11" />
      <WhyChoose data-id="element-12" />
      <Locations data-id="element-13" />
      <FAQ data-id="element-14" />
      <FinalCTA data-id="element-15" />
      <MobileStickyCTA data-id="element-16" />
    </main>;
}